<div class="auth-page">
  <div class="auth-card">
    <h1 class="auth-heading">Forgot Password</h1>
    <p class="auth-subtitle">Enter your username or email to reset your password.</p>

    <form name="forgotForm" #form="ngForm" (ngSubmit)="onSubmit()">
      <div class="flex flex-col gap-4">
        <input pInputText id="email" placeholder="Username or Email" type="email" [(ngModel)]="email" (ngModelChange)="success = false" required
          name="email" [pAutoFocus]="true" class="w-full" />

        <div class="flex gap-2">
          <button pButton pRipple label="Cancel" type="button" class="flex-auto p-button-outlined" routerLink="/"></button>
          <button pButton pRipple label="Submit" type="submit" class="flex-auto" [disabled]="form.invalid || success"
            [loading]="working"></button>
        </div>

        <p class="text-sm text-gray-500 italic text-center mt-1 mb-0">
          If you have not confirmed your email address yet, you get a new invitation instead.
          Click Confirm Email Address in it, and then choose your password.
        </p>

        @if (error) {
          <p class="text-red-500 text-center mt-3 mb-0">{{error}}</p>
        }
        <p class="text-green-500 text-center mt-3 mb-0" *ngIf="success">
          If we find your account, we send you an email in a few minutes:
          "Reset Proximity Password", or a new "Confirm Proximity Email" invitation.
          Check your Junk or Spam folder too.
        </p>
      </div>
    </form>

    <div class="auth-divider mt-6 mb-4">or</div>

    <p class="text-center text-sm text-gray-600 mb-0">
      A problem? <a routerLink="/auth/contact-us" class="text-primary font-medium hover:underline">Click here</a> and let
      us help you.
    </p>
  </div>
</div>
